export default "__VITE_ASSET__4ZFClJBN__"